var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('popup', {
    attrs: {
      "opened": _vm.dataToShow
    },
    on: {
      "close": _vm.close
    }
  }, [_vm.dataToShow ? _c('div', [_c('div', {
    staticClass: "my-5 mx-5 lg:my-15 lg:mx-10 2xl:my-20 2xl:mx-15"
  }, [_c('h3', {
    staticClass: "mb-10"
  }, [_vm._v("Ajouter une compétence manuellement")]), _vm._v(" "), _c('h6', {
    staticClass: "text-indigo-600"
  }, [_vm._v("Saissisez le nom de la compétence à ajouter.")]), _vm._v(" "), _c('h6', {
    staticClass: "text-indigo-600 mb-8"
  }, [_vm._v("Vous pouvez en ajouter plusieurs à la fois en les séparant d’une virgule.")]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center"
  }, [_c('input-text', {
    staticClass: "lg:w-1/2",
    attrs: {
      "error": true,
      "placeholder": "Exemple : “Esprit d'équipe“",
      "value": _vm.competenceName,
      "libelle": "Compétence",
      "name": "competenceName",
      "maxlength": _vm.limit
    },
    on: {
      "input": function (newValue) {
        _vm.competenceName = newValue;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center mt-15"
  }, [_c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-pink-600",
      "bg-color-square": "bg-pink-600",
      "icon-color": "text-white",
      "libelle": "AJOUTER",
      "type-shadow": "shadow-pink"
    },
    on: {
      "clickAction": function ($event) {
        return _vm.addCompetence();
      }
    }
  })], 1)])]) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }